import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-width-wrapper',
  changeDetection: ChangeDetectionStrategy.OnPush,

  template: `
    <div [style.width]="props.width || '100%'">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class FormlyWidthWrapperComponent extends FieldWrapper {}
